import { createReducer, on } from '@ngrx/store';
import { SectorsState } from '../models/sector.model';
import * as SectorsActions from './sectors.actions';

export const initialState: SectorsState = {
  sectors: [],
  selectedSector: null,
  templates: [],
  templateProperties: [],
  loading: false,
  error: null,
  pagination: {
    currentPage: 1,
    pageSize: 20,
    totalItems: 0,
  },
};

export const sectorsReducer = createReducer(
  initialState,

  // Load Sectors
  on(SectorsActions.loadSectors, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(SectorsActions.loadSectorsSuccess, (state, { sectors }) => ({
    ...state,
    sectors,
    loading: false,
    error: null,
  })),
  on(SectorsActions.loadSectorsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load Single Sector
  on(SectorsActions.loadSector, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(SectorsActions.loadSectorSuccess, (state, { sector }) => ({
    ...state,
    selectedSector: sector,
    loading: false,
    error: null,
  })),
  on(SectorsActions.loadSectorFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Create Sector
  on(SectorsActions.createSector, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(SectorsActions.createSectorSuccess, (state, { sector }) => ({
    ...state,
    sectors: [...state.sectors, sector],
    loading: false,
    error: null,
  })),
  on(SectorsActions.createSectorFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Update Sector
  on(SectorsActions.updateSector, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(SectorsActions.updateSectorSuccess, (state, { sector }) => ({
    ...state,
    sectors: state.sectors.map((s) => (s.id === sector.id ? sector : s)),
    selectedSector: sector,
    loading: false,
    error: null,
  })),
  on(SectorsActions.updateSectorFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Delete Sector
  on(SectorsActions.deleteSector, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(SectorsActions.deleteSectorSuccess, (state, { id }) => ({
    ...state,
    sectors: state.sectors.filter((s) => s.id !== id),
    loading: false,
    error: null,
  })),
  on(SectorsActions.deleteSectorFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Templates
  on(SectorsActions.loadTemplates, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(SectorsActions.loadTemplatesSuccess, (state, { templates }) => ({
    ...state,
    templates,
    loading: false,
    error: null,
  })),
  on(SectorsActions.loadTemplatesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Template Properties
  on(SectorsActions.loadTemplateProperties, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(SectorsActions.loadTemplatePropertiesSuccess, (state, { properties }) => ({
    ...state,
    templateProperties: properties,
    loading: false,
    error: null,
  })),
  on(SectorsActions.loadTemplatePropertiesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Clear Selected Sector
  on(SectorsActions.clearSelectedSector, (state) => ({
    ...state,
    selectedSector: null,
  })),

  // Update Pagination
  on(SectorsActions.updatePagination, (state, { currentPage, pageSize, totalItems }) => ({
    ...state,
    pagination: {
      ...state.pagination,
      currentPage: currentPage ?? state.pagination.currentPage,
      pageSize: pageSize ?? state.pagination.pageSize,
      totalItems: totalItems ?? state.pagination.totalItems,
    },
  }))
);
